export default __webpack_public_path__ + "static/media/IST_Logo.ecb229ec.webp";